module.exports = __webpack_public_path__ + "static/uxpoland-12aa0457837b18d91dc17a0a4c112b2f.png";